import { useContext } from "react";
import { useSelector } from "react-redux";

import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  copyDocument(request: Boundaries["copyDocument"]["request"]): void;
}

function useCopyDocument(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isCopyDocumentRequestPending),
    isRequestSuccess: useSelector(selector.isCopyDocumentRequestSuccess),
    isRequestFailure: useSelector(selector.isCopyDocumentRequestFailure),
    copyDocument: core.copyDocument,
  };
}

export { useCopyDocument };
